/**
 * Pastille d'état d'un objet métier (charte, doc 06, § 6.3).
 *
 * `ton` décrit la nature de l'état, jamais une couleur : cela empêche
 * qu'un développeur choisisse « vert » pour un état d'interface, ce que
 * la règle du § 2 interdit.
 */
export type TonPastille = 'neutre' | 'attente' | 'interface' | 'succes' | 'refus';

export function Pastille({ ton = 'neutre', children }: { ton?: TonPastille; children: string }) {
  return <span className={`pastille pastille--${ton}`}>{children}</span>;
}
